import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import { breakpoints, color } from 'shared/style/constants'
import { getPxAsRem } from 'shared/utils'

export const StyledTextInput = styled(TextField)`
    width: 100%;
    margin-bottom: ${getPxAsRem(24)};
    input::-ms-reveal {
        display: none !important;
    }
    input::-ms-clear {
        display: none !important;
    }
`

export const StyledTextInputWithSubtext = styled(TextField)`
    width: 100%;
    margin-bottom: ${getPxAsRem(4)};
    input::-ms-reveal {
        display: none !important;
    }
    input::-ms-clear {
        display: none !important;
    }
`

export const StyledSubtext = styled.div`
    margin-top: ${getPxAsRem(44)};
    display: flex;
    gap: ${getPxAsRem(4)};
    align-items: center;

    @media (max-width: ${breakpoints.md}px) {
        text-wrap: wrap;
    }
`

export const StyledButtonContainer = styled.div`
    margin-top: ${getPxAsRem(24)};
`

export const StyledConfirmationContainer = styled.div`
    background-color: ${color.WHITE};
    padding: ${getPxAsRem(16)};
    display: flex;
    flex-direction: column;
    gap: ${getPxAsRem(16)};
`
